module.exports = __webpack_public_path__ + "img/hero-5-og.b6d7f4f2.jpg";